module.exports = __webpack_public_path__ + "sunsemweb/img/culture4.bbe5f808.jpg";